import templateUrl from './header.html';

export const boHeader = {
    templateUrl,

    controller: class HeaderController {
        /*@ngInject*/
        constructor(AuthSvc) {
            this.AuthSvc = AuthSvc;
        }

        isAuthorized(role) {
            return this.AuthSvc.isAuthorized(role);
        }
    }
};
